import React from "react"
import { Formik } from "formik"
import * as Yup from "yup"
import { RequestAuthLogin } from "../../libs/api/backend/src"
import Label from "../Elements/Form/Label"
import Input from "../Elements/Form/Input"
import FormError from "../Elements/Form/FormError"
import {
  PasswordValidation,
  UsernameValidation,
} from "../../libs/validation/validation"

const validationSchema = Yup.object({
  usernameOrEmail: UsernameValidation,
  password: PasswordValidation,
})

const initialValues = {
  usernameOrEmail: "",
  password: "",
} as RequestAuthLogin

export default function AuthLoginForm({ onSubmit }) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        status,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          {status && (
            <div className="rounded-md border border-red-200 bg-red-50 p-4">
              <div className="flex">
                <div className="ml-1 text-sm text-red-700">{status}</div>
              </div>
            </div>
          )}

          <div className="col-span-6 sm:col-span-6">
            <Label
              htmlFor={"usernameOrEmail"}
              isError={errors.usernameOrEmail && touched.usernameOrEmail}
            >
              Email
            </Label>
            <Input
              type="text"
              name="usernameOrEmail"
              value={values.usernameOrEmail}
              onChange={handleChange}
              onBlur={handleBlur}
              withLabel={true}
              isError={errors.usernameOrEmail && touched.usernameOrEmail}
            />
            <FormError
              isError={errors.usernameOrEmail && touched.usernameOrEmail}
            >
              {errors.usernameOrEmail}
            </FormError>
          </div>

          <div className="col-span-6 sm:col-span-6">
            <Label
              htmlFor={"password"}
              isError={errors.password && touched.password}
            >
              Пароль
            </Label>
            <Input
              type="password"
              name="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              withLabel={true}
              isError={errors.password && touched.password}
            />
            <FormError isError={errors.password && touched.password}>
              {errors.password}
            </FormError>
          </div>

          <div className="col-span-6 sm:col-span-6">
            <button
              type="submit"
              disabled={isSubmitting}
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
            >
              Войти
            </button>
          </div>
        </form>
      )}
    </Formik>
  )
}
